document.addEventListener("DOMContentLoaded", function () {
  // *.*.*.*.*.*.*.*.*.*.* main slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.getElementById("splide")) {
    const splide = new Splide("#splide", {
      type: "loop",
      perPage: 1,
      pagination: true,
      gap: "1em",
      focus: "center",
      drag: false,
      wheel: false,
      autoplay: true,
      interval: 5000,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: "rtl",
      arrows: true,
      pauseOnHover: false,
      breakpoints: {
        768: {
          drag: true,
          wheel: true,
        },
      },
    }).mount();

    // progressBars
    const progressBars = document.querySelectorAll(".splide__pagination__page .progress-bar");
    const resetProgressBars = () => {
      progressBars.forEach((bar) => {
        bar.style.transition = "none";
        bar.style.width = "0%";
      });
    };
    const activateProgressBar = (index) => {
      progressBars[index].style.transition = `width ${splide.options.interval}ms linear`;
      progressBars[index].style.width = "100%";
    };
    activateProgressBar(0);
    splide.on("move", function (newIndex) {
      resetProgressBars();
      activateProgressBar(newIndex);
    });
    splide.on("autoplay", function () {
      resetProgressBars();
    });
  }

  // *.*.*.*.*.*.*.*.*.*.*  END OF main slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* video slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  if (document.getElementById("video_splide")) {
    const splide = new Splide("#video_splide", {
      type: "loop",
      perPage: 3.5, // Show 2 full slides in the center
      focus: "center", // Focus on the center slide
      gap: "1rem",
      trimSpace: false,
      pagination: false,
      arrows: true,
      autoplay: true,
      interval: 5000,
      drag: false,
      wheel: false,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: "rtl",
      breakpoints: {
        991: {
          perPage: 1.5, // Show 1.5 slides in the center on medium screens
          gap: "0.7em",
        },
        768: {
          perPage: 1, // Show 1 slide at a time on smaller screens
          gap: "0.5em",
        },
      },
    });
    splide.mount();
  }

  // *.*.*.*.*.*.*.*.*.*.* END OF video slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* suggested video slider (FRONT_A1) *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  document.querySelectorAll(".suggested_video_slider").forEach(function (slider) {
    new Splide(slider, {
      type: "loop",
      perPage: 1,
      perMove: 1,
      direction: document.documentElement.dir === "ltr" ? "ltr" : "rtl",
      arrows: false,
      pagination: true,
      autoplay: true,
      interval: 5000,
      speed: 600,
      pauseOnHover: true,
      pauseOnFocus: true,
      drag: true,
      updateOnMove: true,
    }).mount();
  });

  // *.*.*.*.*.*.*.*.*.*.* END OF suggested video slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* video thumbnail slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  let mainSliderElement = document.querySelector("#main_slider");
  let thumbnailSliderElement = document.querySelector("#thumbnail-slider");

  if (mainSliderElement || thumbnailSliderElement) {
    let mainSlider = new Splide(mainSliderElement, {
      heightRatio: 0.5,
      pagination: false,
      arrows: false,
      direction: "rtl",
    });

    let thumbnailSlider = new Splide(thumbnailSliderElement, {
      fixedWidth: 200,
      fixedHeight: 130,
      isNavigation: true,
      gap: 8,
      focus: "right",
      pagination: false,
      cover: true,
      arrows: false,
      direction: "rtl",
      rewind: true,
    });

    mainSlider.sync(thumbnailSlider);
    mainSlider.mount();
    thumbnailSlider.mount();

    let progressBar = document.createElement("div");
    progressBar.classList.add("splide-progress");
    progressBar.innerHTML = '<div class="splide-progress-bar"></div>';
    mainSliderElement.appendChild(progressBar);

    function updateProgress() {
      let bar = document.querySelector(".splide-progress-bar");
      if (bar) {
        let progress = (mainSlider.index + 1) / mainSlider.length;
        bar.style.width = progress * 100 + "%";
      }
    }

    updateProgress();
    mainSlider.on("mounted move", updateProgress);
  }

  // *.*.*.*.*.*.*.*.*.*.* END OF video thumbnail slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* category slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  if (document.getElementById("categori_slider")) {
    const splide = new Splide("#categori_slider", {
      perPage: 5.5,
      focus: "right",
      gap: "1rem",
      pagination: false,
      arrows: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: "rtl",
      loop: true,
      autoHeight: true,
      autoWidth: false,
      breakpoints: {
        991: {
          perPage: 4.5,
          gap: "0.7em",
        },
        768: {
          perPage: 2.5,
          gap: "0.5em",
        },
      },
    });
    splide.mount();
  }
  let prev_btn = document.querySelector(".categori_list .splide__arrows .splide__arrow--prev");
  let next_btn = document.querySelector(".categori_list .splide__arrows .splide__arrow--next");
  let firstClick = true;

  if (prev_btn && next_btn) {
    next_btn.addEventListener("click", function () {
      prev_btn.classList.add("active");
      firstClick = false;
    });
  }

  // *.*.*.*.*.*.*.*.*.*.* END OF category slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF main menu *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // Main menu toggle
  const mainMenu = document.querySelector(".top_nav");
  const menuToggleButton = document.querySelector(".menu_btn_cnt");

  if (mainMenu && menuToggleButton) {
    menuToggleButton.addEventListener("click", () => {
      setTimeout(() => {
        mainMenu.classList.toggle("slide_down");
        menuToggleButton.classList.toggle("close_open");
      }, 10);
    });
  }
  // ----- SUB_MENU -----

  document.querySelectorAll(".sub_menu_btn").forEach((subMenuButton) => {
    subMenuButton.addEventListener("click", () => {
      const subMenu = subMenuButton.nextElementSibling;
      if (subMenu && subMenu.classList.contains("sub_menu")) {
        subMenu.classList.toggle("slide_down");
        subMenuButton.classList.toggle("top");
      }
    });
  });

  // ----- END OF SUB_MENU -----
  // fixed menu

  const headerTop = document.querySelector(".header_top");
  const headerMenu = document.querySelector(".header_menu");
  const headerMobile = document.querySelector(".main_header_inner");
  const body = document.querySelector("body");
  const headerNav = document.querySelector(".main_wrapper .top_nav");
  const mainSliderWrapper = document.querySelector(".main_slider_wrapper");

  const headerHeight = headerMenu.offsetHeight;
  const updateDesktopHeaderMode = () => {
    if (!mainSliderWrapper || window.innerWidth < 1201) {
      headerMenu.classList.remove("after-slider-light");
      return;
    }

    headerMenu.classList.toggle("after-slider-light", mainSliderWrapper.getBoundingClientRect().bottom <= 0);
  };

  window.addEventListener("scroll", function () {
    if (window.scrollY >= headerTop.offsetHeight) {
      headerMenu.classList.add("fixed-menu");
      body.style.paddingTop = `${headerHeight}px`;
    } else {
      headerMenu.classList.remove("fixed-menu");
      body.style.paddingTop = "0";
    }
    updateDesktopHeaderMode();
  });
  window.addEventListener("resize", updateDesktopHeaderMode);
  updateDesktopHeaderMode();
  if (window.innerWidth <= 1100) {
    window.addEventListener("scroll", function () {
      if (window.scrollY >= headerMobile.offsetHeight) {
        headerMobile.classList.add("fixed-menu");
      } else {
        headerMobile.classList.remove("fixed-menu");
      }
    });
    headerNav.style.top = "64px";
  }

  // *.*.*.*.*.*.*.*.*.*.* END OF main menu *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF tiny url company page *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".short_link")) {
    var shortLink = document.querySelector(".short_link");
    if (shortLink) {
      shortLink.addEventListener("click", function (event) {
        event.preventDefault();
        var temp = document.getElementById("short_link_copy");
        temp.select();
        document.execCommand("copy");
        document.querySelector(".copied").style.display = "block";
        setTimeout(function () {
          document.querySelector(".copied").style.display = "none";
        }, 1500);
      });
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF tiny url *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* Responsive table *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".editor_styles")) {
    var tables = document.querySelectorAll(".editor_styles table");
    tables.forEach(function (table) {
      var parentTable = document.createElement("div");
      parentTable.classList.add("table_res");
      document.querySelector(".editor_styles").replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }

  // *.*.*.*.*.*.*.*.*.*.* START OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  function setupTabs(tabButtons, contentBoxes, container) {
    const tabs = Array.from(container.querySelectorAll(tabButtons));
    const contents = Array.from(container.querySelectorAll(contentBoxes));
    // fallback: the markup marks the first element as active, so when that
    // element has no data nothing would be selected. open the first one instead.
    if (tabs.length && !tabs.some((tab) => tab.classList.contains("active"))) {
      tabs[0].classList.add("active");
      if (contents[0]) {
        contents[0].classList.add("visible");
      }
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((tab, i) => {
          if (i === index) {
            tab.classList.add("active");
            contents[i].classList.add("visible");
          } else {
            tab.classList.remove("active");
            contents[i].classList.remove("visible");
          }
        });
      });
    });
  }
  // Setting up all the main tab containers
  document.querySelectorAll(".primary_multi_tab").forEach((container) => {
    setupTabs(".tabs_title li", ".tab_content", container);
    // container.querySelectorAll(".tab_content").forEach((tabContent) => {
    // setupTabs(".subtabs > div", ".subtab_content", tabContent);
    // });
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* archive toggle *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
document.querySelectorAll(".flip").forEach(function (el) {
  el.addEventListener("click", function () {
    var panel = el.nextElementSibling;
    var icon = el.querySelector("svg");

    if (panel) {
      panel.classList.toggle("slide_down");
    }

    if (icon) {
      icon.classList.toggle("rotate");
    }
  });
});
  // *.*.*.*.*.*.*.*.*.*.* END OF archive toggle *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* search input mobile *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  let icon_search = document.querySelector(".mobile_search");
  let icons_search = icon_search.querySelector(".search_icon");
  let icons_close = icon_search.querySelector(".close_icon");
  let search_container = document.querySelector(".search_container");

  icon_search.addEventListener("click", () => {
    search_container.classList.toggle("active");
    if (icons_search.classList.contains("active")) {
      icons_search.classList.remove("active");
      icons_close.classList.add("active");
    } else {
      icons_search.classList.add("active");
      icons_close.classList.remove("active");
    }
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF search input mobile *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* BACK TO TOP BUTTON *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  let bottonUp = document.querySelector(".botton_up");
  bottonUp.addEventListener("click", function () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  });

  // *.*.*.*.*.*.*.*.*.*.* END OF BACK TO TOP BUTTON *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* emergency news *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.getElementById("emergency_news")) {
    const splide = new Splide("#emergency_news", {
      type: "loop",
      perPage: 1,
      pagination: false,
      gap: "1em",
      focus: "center",
      drag: false,
      wheel: false,
      autoplay: true,
      interval: 5000,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: "rtl",
      arrows: false,
      pauseOnHover: false,
    }).mount();
  }
  // close
  const emergencyNewsWrapper = document.querySelector(".emergency_news_wrapper");
  const closeNewsButtons = document.querySelectorAll(".close_news");

  closeNewsButtons.forEach((button) => {
    button.addEventListener("click", () => {
      emergencyNewsWrapper.classList.add("deactive");
    });
  });

  // *.*.*.*.*.*.*.*.*.*.* END OF emergency news *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* refresh site *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  
    if (document.body.classList.contains("home")) {
    setTimeout(function () {
      location.reload();
    }, 300000);
  }

    // *.*.*.*.*.*.*.*.*.*.* END OF refresh site *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* dark/light mood *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  const lightBtn = document.querySelector(".theme-switcher-light");
  const darkBtn = document.querySelector(".theme-switcher-dark");
  const savedTheme = localStorage.getItem("theme");
  const setThemeButtonHidden = (button, isHidden) => {
    if (!button) {
      return;
    }

    button.hidden = isHidden;
    button.style.display = isHidden ? "none" : "";
  };
  const updateThemeSwitcher = () => {
    const isLight = document.body.classList.contains("light");

    setThemeButtonHidden(darkBtn, !isLight);
    setThemeButtonHidden(lightBtn, isLight);
  };

  if (savedTheme === "light") {
    document.body.classList.add("light");
  }

  updateThemeSwitcher();

  // Light mode
  lightBtn?.addEventListener("click", () => {
    document.body.classList.add("light");
    localStorage.setItem("theme", "light");
    updateThemeSwitcher();
  });

  // Dark mode
  darkBtn?.addEventListener("click", () => {
    document.body.classList.remove("light");
    localStorage.setItem("theme", "dark");
    updateThemeSwitcher();
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF dark/light mood *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
});
